/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/next";
import { spacing, Text } from "@packages/ui";

const containerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
  height: spacing.full,
  justifyContent: "center",
  paddingLeft: spacing.l,

  paddingRight: spacing.l,
  textAlign: "center",
};

type GroupsEmptyStateProps = {
  isNetwork: boolean;
};

export const GroupsEmptyState = ({ isNetwork }: GroupsEmptyStateProps) => {
  const t = useTranslations();

  return (
    <div css={containerStyles}>
      <Text type="title" size="l">
        {isNetwork ? t("no_groups_title") : t("no_small_groups_title")}
      </Text>
      <Text type="body" size="s">
        {isNetwork
          ? t("no_groups_description")
          : t("no_small_groups_description")}
      </Text>
    </div>
  );
};
